import { Bar, Pie, Line } from 'react-chartjs-2';

import { useTranslation } from '../locale/useTranslation';

const generatePalette = (count) =>
  Array.from({ length: count }, (_, i) =>
    `hsl(${(i * 360) / count}, 70%, 55%)`
  );


const ChartRenderer = ({ chart }) => {
    const { t, language, setLanguage } = useTranslation();    

  if (
    !chart.data ||
    !chart.data.datasets ||
    chart.data.datasets.length === 0 ||
    chart.data.datasets.every(ds => !ds.data || ds.data.length === 0)
  ) {
    return (
      <div
        style={{
          height: 250,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#999',
          fontStyle: 'italic',
        }}
      >
        {t("Aucune donnée à afficher")}
      </div>
    );
  }

    const translateIfNeeded = (value, chart) =>  {
        return chart.translate ? t(value) : value;  
    }

  // Injection automatique des couleurs
    const preparedData = {
    ...chart.data,
    labels: chart.data.labels?.map(label =>
        chart.type === 'pie' ? translateIfNeeded(label, chart) : label
    ),
    datasets: chart.data.datasets.map((ds, index) => {
        // BAR / LINE → 1 couleur par dataset
        if (chart.type === 'bar' || chart.type === 'line') {
            const palette = generatePalette(chart.data.datasets.length);
            return {
                ...ds,
                backgroundColor: ds.backgroundColor ?? palette[index],
                borderColor: palette[index],
                
                label: ds.label ? translateIfNeeded(ds.label, chart) : undefined
                }
        };

        // PIE → 1 couleur par valeur
        if (chart.type === 'pie') {
          return {
              ...ds,
              backgroundColor:
              ds.backgroundColor ?? generatePalette(ds.data.length),
              labels: chart.data.labels?.map(label =>
                  translateIfNeeded(label, chart)
              )
          };
        }

        return ds;
    }),
    };

  const options = {
    responsive: true,

    plugins: {
      title: {
        display: true,
        text: t(chart.title),
      },
      legend: {
        position: 'bottom',
      },
    },
  };

if (chart.type === 'bar') {
  options.scales = {
    x: { stacked: false },
    y: { beginAtZero: true },
  };
}  


  switch (chart.type) {
    case 'bar':
      return <Bar data={preparedData} options={options} />;
    case 'pie':
      return <Pie data={preparedData} options={options} />;
    case 'line':
      return <Line data={preparedData} options={options} />;
    default:
      return <p>Type de graphique non supporté : {chart.type}</p>;
  }
};

export default ChartRenderer;
